import { getApiBaseUrl } from '@/services/api';

export interface ExtensionDownload {
  version: string;
  href: string;
  folder: string;
  server: string;
}

/** The extension's own name for each server it can upload to (packages/capture-extension/src/capture/account.ts). */
const SERVERS: Array<[RegExp, string]> = [
  [/\/\/api-beta\.4klabs\.ai\b/, '4K Labs beta'],
  [/\/\/api(-aws)?\.4klabs\.ai\b/, '4K Labs'],
];

/** The extension zip this build packaged (vite.config.ts), on a server the extension can upload to. */
export function extensionDownload(): ExtensionDownload | null {
  const version = import.meta.env.VITE_CAPTURE_EXTENSION_VERSION as string | undefined;
  const server = SERVERS.find(([api]) => api.test(getApiBaseUrl()))?.[1];
  if (!version || !server) return null;
  return { version, href: `/downloads/4klabs-capture-${version}.zip`, folder: `4klabs-capture-${version}`, server };
}
